<ngx-avatar [name]="getShortName()" [size]="size" [fgColor]="fgColor || getAvatarVariant().fgColor"
  [bgColor]="bgColor || getAvatarVariant().bgColor" [borderColor]="borderColor" [textSizeRatio]="textSizeRatio"
  [round]="cornerRadius != null ? false : round" [cornerRadius]="cornerRadius" [src]="src" [initialsSize]="initialsSize" [value]="value">
</ngx-avatar>
